module.exports = {
      id: "philp-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#philp-flag",
      toString: function () {
        return this.url;
      }
    }